package com.zaurh.mapquizwebsite.data.service

import io.ktor.client.HttpClient
import io.ktor.client.plugins.expectSuccess
import io.ktor.client.request.get
import io.ktor.client.statement.HttpResponse
import io.ktor.http.ContentType
import io.ktor.http.contentType

class UserApi(private val client: HttpClient) {
    suspend fun getUserData(): HttpResponse {
        return client.get("users-web/me") {
            contentType(ContentType.Application.Json)
            expectSuccess = false
        }
    }
}